import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { Token, Company, UserCode } from '../../utils/users';
import { errorResponse } from '../../utils/response';

export function getDefaultParam() {
    let url = 'param/getDefaultParam?' + objectToQueryString({ company: Company(), userCode: UserCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let param = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getDefaultParamPE() {
    let url = 'param/getDefaultParamPE?' + objectToQueryString({ company: Company(), userCode: UserCode(), token: Token() });

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                let param = response.list;

                //saveConfig(wage);

                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}